import React, { Context, createContext, useContext, useState } from 'react';

export const SignupContext: Context<{
  loading: boolean;
  setLoading: (...args) => any;
  generalError: string;
  setGeneralError: (...args) => any;
}> = createContext({
  loading: null,
  setLoading: () => {},
  generalError: null,
  setGeneralError: () => {},
});

export default function SignupProvider(props) {
  const [loading, setLoading] = useState(false);
  const [generalError, setGeneralError] = useState(null);

  return (
    <SignupContext.Provider
      value={{ loading, setLoading, generalError, setGeneralError }}
    >
      {props.children}
    </SignupContext.Provider>
  );
}

export const useSignupContext = () => useContext(SignupContext);
